import React from 'react';
import Select from '../../../components/ui/Select';

import { Checkbox } from '../../../components/ui/Checkbox';
import EnhancedAdditionalContext from './EnhancedAdditionalContext';

const CurrentIssuesStep = ({ formData, onChange, errors }) => {
  const issueCategories = [
    { value: 'anxiety', label: 'Anxiety & Stress' },
    { value: 'depression', label: 'Depression & Low Mood' },
    { value: 'grief', label: 'Grief & Loss' },
    { value: 'relationships', label: 'Relationship Issues' },
    { value: 'work-stress', label: 'Work-related Stress' },
    { value: 'academic', label: 'Academic Pressure' },
    { value: 'trauma', label: 'Trauma & PTSD' },
    { value: 'addiction', label: 'Addiction & Substance Use' },
    { value: 'eating', label: 'Eating Concerns' },
    { value: 'sleep', label: 'Sleep Issues' },
    { value: 'identity', label: 'Identity & Self-esteem' },
    { value: 'life-transitions', label: 'Life Transitions' },
    { value: 'chronic-illness', label: 'Chronic Illness Management' },
    { value: 'other', label: 'Other' }
  ];

  const symptomOptions = [
    { value: 'overwhelming-worry', label: 'Overwhelming worry' },
    { value: 'panic-attacks', label: 'Panic attacks' },
    { value: 'persistent-sadness', label: 'Persistent sadness' },
    { value: 'loss-of-interest', label: 'Loss of interest in activities' },
    { value: 'difficulty-concentrating', label: 'Difficulty concentrating' },
    { value: 'sleep-problems', label: 'Sleep problems' },
    { value: 'appetite-changes', label: 'Appetite changes' },
    { value: 'fatigue', label: 'Constant fatigue' },
    { value: 'irritability', label: 'Irritability or anger' },
    { value: 'social-withdrawal', label: 'Social withdrawal' },
    { value: 'physical-symptoms', label: 'Physical symptoms (headaches, pain)' },
    { value: 'intrusive-thoughts', label: 'Intrusive thoughts' }
  ];

  const durationOptions = [
    { value: 'less-than-week', label: 'Less than a week' },
    { value: '1-2-weeks', label: '1-2 weeks' },
    { value: '2-4-weeks', label: '2-4 weeks' },
    { value: '1-3-months', label: '1-3 months' },
    { value: '3-6-months', label: '3-6 months' },
    { value: 'more-than-6-months', label: 'More than 6 months' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-2">
          Current Issues & Symptoms
        </h3>
        <p className="text-sm text-muted-foreground">
          Help us understand what you're experiencing right now
        </p>
      </div>
      <Select
        label="What brings you here today?"
        placeholder="Select primary concern(s)"
        options={issueCategories}
        value={formData?.currentIssues || []}
        onChange={(value) => onChange('currentIssues', value)}
        multiple
        searchable
        description="Select all that apply - you can choose multiple"
        required
        error={errors?.currentIssues}
      />
      <Select
        label="Symptoms you're experiencing"
        placeholder="Select symptoms"
        options={symptomOptions}
        value={formData?.symptoms || []}
        onChange={(value) => onChange('symptoms', value)}
        multiple
        searchable
        description="Optional - helps helpers prepare for your session"
        error={errors?.symptoms}
      />
      <Select
        label="How long have you been experiencing this?"
        placeholder="Select duration"
        options={durationOptions}
        value={formData?.duration || ''}
        onChange={(value) => onChange('duration', value)}
        description="Helps us understand the timeline"
        error={errors?.duration}
      />
      <EnhancedAdditionalContext
        formData={formData}
        onChange={onChange}
        errors={errors}
      />
      <div className="space-y-3">
        <label className="text-sm font-medium text-foreground">
          Previous Support
        </label>
        <Checkbox
          label="I have existing mental health conditions"
          checked={formData?.hasExistingConditions || false}
          onChange={(e) => onChange('hasExistingConditions', e?.target?.checked)}
          description="We'll match you with helpers experienced in ongoing care"
        />
        <Checkbox
          label="I'm currently seeing a mental health professional"
          checked={formData?.currentlyInTreatment || false}
          onChange={(e) => onChange('currentlyInTreatment', e?.target?.checked)}
          description="This support can complement your existing care"
        />
      </div>
      <div className="p-4 bg-warning/10 rounded-lg border border-warning/20">
        <div className="flex items-start gap-3">
          <span className="text-warning text-xl">⚠️</span>
          <div className="text-sm">
            <p className="text-foreground font-medium mb-1">Crisis Support Available</p>
            <p className="text-muted-foreground">
              If you're experiencing a mental health emergency or having thoughts of self-harm, please call XXX (Suicide & Crisis Lifeline) immediately or visit your nearest emergency room.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentIssuesStep;